import { createContext, useContext, useRef } from "react";

export const GlobalContext = createContext<{
  devtoolsRef: React.RefObject<HTMLDivElement>;
}>({
  devtoolsRef: { current: null },
});

export const GlobalProvider = ({ children }: { children: React.ReactNode }) => {
  const devtoolsRef = useRef<HTMLDivElement>(null);

  return (
    <GlobalContext.Provider value={{ devtoolsRef }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  }
  return context;
};
